import React from 'react'
import Card from '@mui/joy/Card';
import CardContent from '@mui/joy/CardContent';
import Typography from '@mui/joy/Typography';
import "../ContentSeo/TitleDivSeo.css";
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { useState } from 'react';
import { Button } from '@mui/material';
function AnylsticsTools(props) {

    
    const [open, setOpen] = useState(false);
    const handleClickOpen = () => {
        setOpen(true);
      };
    
      const handleClose = (e) => {
        setOpen(false);
      }



  return (
    <div  id={`section-${props.index}`}>
      <div style={{marginTop:"10px"}} className='TitleDivSeo' onClick={handleClickOpen}>
      <div className="CARD" onClick={handleClickOpen}>
       <div
        style={{
          background: 'linear-gradient(to right, #ffcc00, #ff9900)', // Use your preferred background style
          padding: '10px',
          borderRadius:"5px",
          opacity:"0.6",
          color:"white"
        }}
      >
        <h3>تحــلــيـــلات</h3>
      </div>
       <Card orientation="horizontal" variant="outlined" sx={{ width: "100%",textAlign:"right"}}>
      <CardContent>
        <Typography fontWeight="md" textColor="success.plainColor"> 
           {props.CheckAnaylstics ? "جيد لديك أدوات تحليل لموقعك" : "لم نكتشف أداة تحليلات مثبتة على هذا الموقع."}
        </Typography> 
</CardContent>
{ props.CheckAnaylstics ?
  <CheckIcon style={{ color: "#27ae60", fontSize: "50px" }} /> : 
  <ClearIcon style={{ color: "red",fontSize: "50px" }} />}
    </Card>
    </div>
    <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent style={{direction:"rtl"}}>
          <DialogContentText id="alert-dialog-description" style={{color:"rgb(78, 181, 76)"}}>
          تتيح لك تحليلات الويب قياس نشاط الزائر على موقع الويب الخاص بك.
يجب أن يكون لديك أداة تحليلات واحدة على الأقل مثبتة ، ولكن قد يكون من الجيد أيضا تثبيت أداة ثانية للتحقق من البيانات.
          </DialogContentText>
        </DialogContent>
        <Button onClick={(e) => { e.stopPropagation(); handleClose(); }}>close</Button>
      </Dialog>
    </div>
    </div>
  )
}
export default AnylsticsTools